import ErrorBoundary from '../../../utils/ErrorBoundary';
import { Component } from 'react';

function withErrorBoundary(WrappedComponent) {
	class withErrorBoundary extends Component {
		render() {
			return (
				<ErrorBoundary>
					<WrappedComponent {...this.props} />
				</ErrorBoundary>
			);
		}
	}
	return withErrorBoundary;
}

export default withErrorBoundary;
